"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnrecognizedDocumentsRestService = void 0;
const BaseRestService_1 = __importDefault(require("../BaseRestService"));
const utils_1 = require("@sqvr/utils");
class UnrecognizedDocumentsRestService extends BaseRestService_1.default {
  constructor() {
    super(...arguments);
    this.basePath = '/meetings';
    this.deleteDocuments = (request, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const {
        meetingId,
        ids
      } = request;
      const data = {
        ids
      };
      return this.send(utils_1.DELETE, null, `/${meetingId}/bulletins/files`, Object.assign(Object.assign({}, options), {
        body: JSON.stringify(data)
      }), requestOptions);
    });
    this.deleteBulletinFile = (request, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const {
        meetingId,
        bulletinId,
        fileId,
        comment,
        comment_attachments
      } = request;
      if (comment_attachments.length) {
        comment_attachments.forEach(file => {
          file.file_uuid = file.fileUuid;
          delete file.fileUuid;
        });
      }
      let data = {
        ids: [fileId],
        comment: {
          body: comment,
          attachments: comment_attachments
        }
      };
      return this.send(utils_1.DELETE, null, `/${meetingId}/bulletins/${bulletinId}/files`, Object.assign(Object.assign({}, options), {
        body: JSON.stringify(data)
      }), requestOptions);
    });
    this.addDocumentToBulletin = (request, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const {
        meetingId,
        bulletinId,
        fileId,
        pageNumber,
        documentType,
        force,
        comment,
        files = []
      } = request;
      if (files.length) {
        files.forEach(file => {
          file.file_uuid = file.fileUuid;
          delete file.fileUuid;
        });
      }
      let data = {
        unrecognized_file_id: fileId,
        page_number: pageNumber,
        document_type: documentType,
        force: force || false,
        comment: {
          body: comment,
          attachments: files
        }
      };
      return this.send(utils_1.PATCH, null, `/${meetingId}/bulletins/${bulletinId}/files`, Object.assign(Object.assign({}, options), {
        body: JSON.stringify(data)
      }), requestOptions);
    });
    this.moveDocumentToBulletin = (request, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const {
        meetingId,
        bulletinId,
        fileId,
        pageNumber,
        documentType,
        moveTo,
        comment,
        force,
        files
      } = request;
      if (files === null || files === void 0 ? void 0 : files.length) {
        files.forEach(file => {
          file.file_uuid = file.fileUuid;
          delete file.fileUuid;
        });
      }
      let data = {
        file_id: fileId,
        page_number: pageNumber,
        document_type: documentType,
        to_bulletin_id: moveTo,
        comment: {
          body: comment,
          attachments: files
        },
        force: force || false
      };
      return this.send(utils_1.PATCH, null, `/${meetingId}/bulletins/${bulletinId}/files/move`, Object.assign(Object.assign({}, options), {
        body: JSON.stringify(data)
      }), requestOptions);
    });
    this.downloadDocuments = (request, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const {
        meetingId,
        ids,
        admin_panel = false
      } = request;
      let data = {
        ids,
        admin_panel
      };
      return this.send(utils_1.POST, null, `/${meetingId}/bulletin_files/download`, Object.assign(Object.assign({}, options), {
        body: JSON.stringify(data)
      }), requestOptions);
    });
    this.getDocuments = (request, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const {
        count,
        page,
        meetingId,
        search,
        sort,
        filters
      } = request;
      const result = filters.reduce((acc, obj) => {
        acc[obj.type] = obj.items;
        return acc;
      }, {});
      let params = `limit=${count}`;
      if (page) {
        params += `&page=${page}`;
      }
      if (search) {
        params += `&search=${search}`;
      }
      if (sort) {
        params += `&sort=${sort.columnId}|${sort.order}`;
      }
      if (filters.length) {
        params += `&filters=${encodeURI(JSON.stringify(result))}`;
      }
      return this.send(utils_1.GET, params, `/${meetingId}/bulletins/files`, options, requestOptions);
    });
  }
}
exports.UnrecognizedDocumentsRestService = UnrecognizedDocumentsRestService;
const unrecognizedDocumentsRestService = new UnrecognizedDocumentsRestService();
exports.default = unrecognizedDocumentsRestService;